import React, { useState } from 'react'
import '../../css/topbar.css';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { useDispatch, useSelector } from 'react-redux';
import { logout } from '../../../redux/auth';
import { ApiService } from '../../services/apiService';
import ErrorOutlineRoundedIcon from '@mui/icons-material/ErrorOutlineRounded';
import { DialogContentText, Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, } from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import Warning from '../alert/Warning';

const theme = createTheme();

export default function Topbar() {
	const dispatch = useDispatch();
	const authData = useSelector(state => state.auth);
	const [open, setOpen] = useState(false);
	const [alertOpen, setAlertOpen] = useState(false);
	const [email, setEmail] = useState('');
	const [password, setPassword] = useState('');
	const [confirmPassword, setConfirmPassword] = useState('');
	const userId = authData.user.email.split('@')[0];
	const navigate = useNavigate();
	const [openWarning, setOpenWarning] = useState(false);
	const [errorMsg, setErrorMsg] = useState('');

	const getAdminData = () => {
		setEmail(authData.user.email);
		setPassword("");
		setConfirmPassword("");
	}

	const handleOpen = () => {
		setOpen(true);
		getAdminData();
	}

	const validCheck = () => {
		const passwordRex = /^(?=.*[a-zA-Z])(?=.*[-_!@#$%^*+=])(?=.*[0-9])(?!.*[^-_!@#$%^*+=0-9a-zA-Z]).{10,}$/;

		const continueCheck = (pwd) => {
			let o = 0;
			let d = 0;
			let p = 0;
			let n = 0;  
			let limit = 3;
			
			for(let i = 0; i < pwd.length; i++) {
				const tempVal = pwd.charAt(i);
				if(i > 0 && (p = o - tempVal) > -2 && (n = p === d ? n + 1 :0) > limit -3) {
					return true;
				}
				d = p;
				o = tempVal;
			}
			return false;
		}
		
		if((password === '') && (confirmPassword === '')) {
			setOpenWarning(true);
			setErrorMsg('비밀번호를 입력하세요!');
			return false;
		}

		if((password !== '') || (confirmPassword !== '')) {
			if(password !== confirmPassword) {
				setOpenWarning(true);
				setErrorMsg('입력한 비밀번호가 서로 다릅니다!');
				return false;
			}

			if (!passwordRex.test(password)) {
				setOpenWarning(true);
				setErrorMsg('비밀번호는 영문, 특수문자(!@#$%^*+=_-), 숫자 조합으로 10자 이상이어야 합니다!');
				return false;
			}

			if(continueCheck(password)) {
				setOpenWarning(true);
				setErrorMsg('3개 이상 연속된 숫자는 입력할 수 없습니다!');
				return false;
			}
		}

		return true;
	}

	const handleEdit = async () => {
		if(validCheck()) {
			const adminData = {
				"password": password,
				"confirmPassword": confirmPassword,
			};

			try {
				await ApiService.modifyPassword(adminData);
				closeHandle();
				userLogout();
			} catch(error) {
				console.log('Topbar - handleEdit - error :: ', error)
			}
		}
	}

	const closeWarning = (data) => {
		setOpenWarning(data);
	}

	const closeHandle = () => {
		setOpen(false);
		setPassword('');
		setConfirmPassword('');
	}

	const alertCloseHandle = () => {
		setAlertOpen(false);
	}

	const alertOpenHandle = () => {
		setAlertOpen(true);
	}

	const userLogout = () => {
		setAlertOpen(false);
		dispatch(logout());
	}

	const handleChangePassword = (event) => {
		setPassword(event.target.value);
	};

	const handleChangeConfirmPassword = (event) => {
		setConfirmPassword(event.target.value);
	};

	const logoClick = () => {
		navigate('/');
	}

	return (
		<ThemeProvider theme={theme}>
			<div className="topbar">
				<div className="topbarWrapper">
					<div className="topLeft">
						<div className="logo" onClick={logoClick}>FineVu Cloud</div>
					</div>
					<div className="topRight">
						{/* <div className="qrcode">QR코드</div> */}
						<div className="topbarIconContainer">
							{userId}님 환영합니다!
						</div>
						<div className="topbarIconContainer" onClick={handleOpen}>
							<AccountCircleIcon sx={{"fontSize":"28px", "cursor": "pointer"}}/>
						</div>
						<div className="topbarIconContainer" onClick={alertOpenHandle}>
							<ExitToAppIcon sx={{"fontSize":"28px", "cursor": "pointer"}}/>
						</div>
					</div>
				</div>
			</div>

			{/* modal */}
			<Dialog open={open} onClose={closeHandle} aria-labelledby="form-dialog-title" sx={{ height: '800px'}}>
				<DialogTitle id="form-dialog-title" >마이페이지</DialogTitle>
				<DialogContent>
					<TextField
						label="Email"
						maxRows={4}
						disabled 
						value={email}
						sx={{ width: "550px", mb: 3, mt:2}}
						variant="outlined"
						InputLabelProps={{
							shrink: true,
						}}
					/>
					<TextField
						label="Password"
						maxRows={4}
						sx={{ width: "550px", mb: 3}}
						value={password}
						onChange={handleChangePassword}
						type="password"
						variant="outlined"
						InputLabelProps={{
							shrink: true,
						}}
						placeholder="새 비밀번호 입력"
					/>	
					<TextField
						label="Confirm Password"
						maxRows={4}
						sx={{ width: "550px", mb: 3}}
						value={confirmPassword}
						onChange={handleChangeConfirmPassword}
						type="password"
						variant="outlined"
						InputLabelProps={{
							shrink: true,
						}}
						placeholder="비밀번호 확인(다시입력)"
					/>
				</DialogContent>
				<DialogActions sx={{ pr: '25px', mt: 1, mb: 3}}>
					<Button onClick={closeHandle} sx={{ backgroundColor: '#999999', color:"#FFFFFF", '&:hover': { backgroundColor: '#999999'}}} >취소</Button>	
					<Button onClick={handleEdit} variant="contained">
						수정
					</Button>		
				</DialogActions>
			</Dialog>

			<Warning
				open={openWarning}
				onHideWarning={closeWarning}
				warningMsg={errorMsg}
			></Warning>
			
			<Dialog
				open={alertOpen}
				onClose={alertCloseHandle}
				aria-labelledby="responsive-dialog-title"
			>
				<DialogTitle id="responsive-dialog-title" sx={{ width: '350px', fontWeight: 600}}>
					<ErrorOutlineRoundedIcon sx={{pr:1, verticalAlign: "-4px"}}/>알림
				</DialogTitle>
				<DialogContent>
					<DialogContentText sx={{fontWeight: 600, m:"15px 0px 0px 10px"}}>
						로그아웃 하시겠습니까?
					</DialogContentText>
				</DialogContent>
				<DialogActions sx={{p: "8px 20px 10px 8px"}}>
					<Button onClick={alertCloseHandle} variant="outlined">
						취소
					</Button>
					<Button onClick={userLogout} variant="outlined">
						확인
					</Button>
				</DialogActions>
			</Dialog>
		</ThemeProvider>
  	)
}
 